import { StaticDashboard as MetabaseStaticDashboard } from '@surepathai/embedding-sdk-react';
import { FC } from 'react';
import InlineToast from '../toasts/inline';
import MetabaseContainer from './metabase-container';
import { MetabaseContainerProps } from './helpers';

interface StaticDashboardProps extends MetabaseContainerProps {
  dashboardId: string;
  initialParameters: Record<string, string>;
  hiddenParameters: string[];
}

export const StaticDashboard: FC<StaticDashboardProps> = ({
  dashboardId,
  initialParameters,
  hiddenParameters,
  ...metabaseContainerProps
}) => {
  if (!dashboardId) {
    return <InlineToast message="Insights are temporarily unavailable" level="info" />;
  }

  return (
    <MetabaseContainer {...metabaseContainerProps}>
      <MetabaseStaticDashboard
        dashboardId={dashboardId}
        initialParameters={initialParameters}
        hiddenParameters={hiddenParameters}
        withTitle={false}
        onLoad={() => window.dispatchEvent(new Event('resize'))}
      />
    </MetabaseContainer>
  );
};
